ApprovalDetails = require 'components/scope/outcomes/approval_details'
Todos = require 'components/common/todos'
CheckboxInput = require 'components/common/checkbox_input'
PreviousComments = require 'components/scope/questions/grouped_comments_blocks'
MembersCommentsBlock = require 'components/scope/members_comments'
approvalStep = require('lib/questions_helper').OUTCOMES_GENERATION_STEPS[5]
CustomRenderMixin = require 'components/mixins/custom_render_mixin'
Translation = require 'components/mixins/translation'

ApprovalComments = createReactClass
  displayName: 'ApprovalComments'

  propTypes:
    approvalsByValue: PropTypes.instanceOf(Immutable.Map).isRequired
    approvalComments: PropTypes.instanceOf(Immutable.Map).isRequired
    membersMap: PropTypes.instanceOf(Immutable.Map).isRequired

  mixins: [
    CustomRenderMixin
    Translation('scope:questions')
  ]

  _getCommentsByApproval: ->
    getCommentsByApproval = (value) =>
      @props.approvalsByValue.get(value, Immutable.Map())
        .filter (v, memberId) => @props.approvalComments.has memberId
        .mapEntries ([memberId, v]) => [memberId, @props.approvalComments.get memberId]
    # return a tupple of [disagreeComments, agreeComments]
    [ getCommentsByApproval(false), getCommentsByApproval true ]

  render: ->
    [ disagreeComments, agreeComments ] = @_getCommentsByApproval()

    <div>
      <MembersCommentsBlock
        blockTitleText={"#{@i18n 'approval.disagreement_comments_title'}:"}
        membersComments={disagreeComments}
        membersMap={@props.membersMap}
      />
      {unless agreeComments.isEmpty()
        <MembersCommentsBlock
          blockTitleText={"#{@i18n 'approval.agreement_comments_title'}:"}
          membersComments={agreeComments}
          membersMap={@props.membersMap}
        />
      }
    </div>

OutcomeApprovalDetailsExtended = createReactClass
  displayName: 'OutcomeApprovalDetailsExtended'

  propTypes:
    outcome: PropTypes.instanceOf(Immutable.Map).isRequired
    membersMap: PropTypes.instanceOf(Immutable.Map).isRequired
    setDisagreementResolved: PropTypes.func.isRequired
    saveTodos: PropTypes.func
    onApplyAdminComment: PropTypes.func
    readOnly: PropTypes.bool

  mixins: [
    CustomRenderMixin
    Translation('scope:outcomes')
  ]

  _getOriginalImportance: ->
    @props.outcome.get 'importanceOriginal', @props.outcome.get 'importance'

  _isDisagreementResolved: ->
    @props.outcome.get 'importanceDisagreementResolved', false

  _getPreviousStepsComments: ->
    @props.outcome.get('memberComments', Immutable.Map())
      .filterNot (comments, stepName) ->
        stepName is approvalStep or comments.isEmpty()

  getAdminComment: ->
    @approvalAdminComment.value

  saveTodos: (todos) ->
    key = @props.outcome.get 'key'
    @props.saveTodos { key, todos }

  toggleDisagreementResolution: ->
    currentState = @_isDisagreementResolved()
    key = @props.outcome.get 'key'
    { gIndex } = @props
    @props.setDisagreementResolved { key, gIndex, value: not currentState }

  render: ->
    approvalComments = @props.outcome.getIn ['memberComments', approvalStep]
    approvalsByValue = @props.outcome.get('approvals').groupBy (v) -> v
    approvalAdminComment = @props.outcome.getIn ['adminComments', approvalStep]

    <div className='outcome-details'>
      <div className='step-name'>
        {@i18n 'approval_phase'}
      </div>
      <div className='extended-details-container'>
        <div className='extended-details-block'>
          <ApprovalDetails
            approvals={@props.outcome.get 'approvals'}
            originalImportance={@_getOriginalImportance()}
            groupType={@props.groupType}
          />
          <CheckboxInput
            id='disagreement'
            defaultChecked={@_isDisagreementResolved()}
            onChange={@toggleDisagreementResolution}
            disabled={@props.readOnly}
          />
          <label htmlFor='disagreement'>
            <b> {@i18n '../questions.approval.disagreement_resolved'}</b>
          </label>
        </div>
        <div className='extended-details-block with-todos'>
          <div className='my-comment'>
            <div className='title'><b>{@i18n 'my_comment'}:</b></div>
            {if @props.readOnly
              <div className='admin-comment'>
                {approvalAdminComment}
              </div>
            else
              <textarea
                ref={(el) => @approvalAdminComment = el}
                defaultValue={approvalAdminComment}
              />
            }
          </div>
          <div>
            <div className='title'><b>{@i18n '../questions.approval.to_do'}:</b></div>
            <Todos
              todos={@props.todos}
              saveTodos={@saveTodos}
              readOnly={@props.readOnly}
            />
          </div>
        </div>
      </div>
      <ApprovalComments
        approvalsByValue={approvalsByValue}
        approvalComments={approvalComments}
        membersMap={@props.membersMap}
      />
      <PreviousComments
        itemIdOrKey={@props.outcome.get 'key'}
        membersComments={@_getPreviousStepsComments()}
        adminComments={@props.outcome.get 'adminComments'}
        membersMap={@props.membersMap}
        onApplyAdminComment={@props.onApplyAdminComment}
        readOnly={@props.readOnly}
      />
    </div>

module.exports = OutcomeApprovalDetailsExtended
